import TvOwners from '@/core/services/tv.owners';
import TvLicenses from '@/core/services/tv.licenses';
import TvFolders from '@/core/services/tv.folders';
import TvVideos from '@/core/services/tv.videos';
import StoriesOwners from '@/core/services/stories.owners';
import StoriesLicenses from '@/core/services/stories.licenses';
import StoriesNarrators from '@/core/services/stories.narrators';
import StoriesAuthors from '@/core/services/stories.authors';
import StoriesFolders from '@/core/services/stories.folders';
import StoriesBooks from '@/core/services/stories.books';
import GeneralCoupons from '@/core/services/general.coupons';
import GeneralUsers from '@/core/services/general.users';

export default {
  tv: {
    ...TvOwners,
    ...TvLicenses,
    ...TvFolders,
    ...TvVideos,
  },
  stories: {
    ...StoriesOwners,
    ...StoriesLicenses,
    ...StoriesNarrators,
    ...StoriesAuthors,
    ...StoriesFolders,
    ...StoriesBooks,
  },
  general: {
    ...GeneralUsers,
    ...GeneralCoupons,
  },
};
